export default [{
    path: '/',
    redirect: '/web/auth/login'
  },
  {
    path: '/web/auth/login',
    name: 'auth.login',
    meta: {
      name: '用户登录'
    },
    component: () => import('@/views/web/auth/Login.vue')
  },
  {
    path: '/web/register/mobile',
    name: 'register.mobile',
    meta: {
      name: '手机注册'
    },
    component: () => import('@/views/web/register/Mobile.vue')
  },
  {
    path: '/web/register/email',
    name: 'register.email',
    meta: {
      name: '邮箱注册'
    },
    component: () => import('@/views/web/register/Email.vue')
  },
  {
    path: '/web/register/email/code/:token/',
    name: 'register.email.code',
    meta: {
      name: '邮箱注册（邮箱验证）'
    },
    component: () => import('@/views/web/register/Code.vue')
  },
  {
    path: '/web/password/email/',
    name: 'password.email',
    meta: {
      name: '邮箱密码重置'
    },
    component: () => import('@/views/web/password/Email.vue')
  },
  {
    path: '/web/password/email/code/:token/',
    name: 'password.email.code',
    meta: {
      name: '邮箱密码重置（验证）'
    },
    component: () => import('@/views/web/password/Code.vue')
  },
  {
    path: '/web/password/mobile',
    name: 'password.mobile',
    meta: {
      name: '手机密码重置'
    },
    component: () => import('@/views/web/password/Mobile.vue')
  },
  {
    path: '/web/user/email/code/:token/',
    name: 'user.email.code',
    meta: {
      name: '验证邮箱绑定'
    },
    component: () => import('@/views/web/user/email/Code.vue')
  },
  {
    path: '/',
    name: 'index',
    component: () => import('@/views/Index.vue')
  }
]


// WEBPACK FOOTER //
// ./src/router/modules/web.js